import {
    ToolbarButton,
    type ToolbarButtonProps,
} from '@fluentui/react-components';
import { createLink } from '@tanstack/react-router';
import { forwardRef } from 'react';

export const ToolbarLink = createLink(
    forwardRef<HTMLAnchorElement, Omit<ToolbarButtonProps, 'as'>>(
        (props, ref) => <ToolbarButton {...(props as any)} as="a" ref={ref} />
    )
);
